import React from 'react';
import type { EvaluationItem, NumericConfig } from '../../../../../types/course';
import FloatingLabelPill from '../shared/FloatingLabelPill';
import SectionHeader from '../shared/SectionHeader';
import TrashButton from '../shared/TrashButton';

interface ItemEditorProps {
  item: Extract<EvaluationItem, { type: 'numeric_input' }>;
  onChange: (patch: Partial<Extract<EvaluationItem, { type: 'numeric_input' }>>) => void;
  onDelete: () => void;
  readOnly?: boolean;
}

const pillInputClass =
  'w-full h-[46px] px-[18px] rounded-[50px] border border-text-secondary bg-transparent text-text-primary font-sans text-sm outline-none focus:border-primary-500 transition-colors';

export default function NumericInputItem({ item, onChange, onDelete, readOnly }: ItemEditorProps) {
  const { question, correct_value, tolerance } = item.config;

  const updateConfig = (patch: Partial<NumericConfig>) => {
    onChange({ config: { ...item.config, ...patch } });
  };

  return (
    <div className="flex flex-col gap-[31px] w-full">
      <SectionHeader title="Numeric Input" />
      <FloatingLabelPill
        label="Question"
        value={question}
        onChange={(v) => updateConfig({ question: v })}
        placeholder="What is the numeric answer?"
        size="xl"
        readOnly={readOnly}
        trailingIcon={!readOnly && <TrashButton onClick={onDelete} ariaLabel="Delete question" />}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="flex flex-col gap-2 font-sans text-xs text-text-secondary">
          Correct value
          <input
            type="number"
            value={Number.isFinite(correct_value) ? correct_value : ''}
            onChange={(e) =>
              updateConfig({ correct_value: e.target.value === '' ? 0 : Number(e.target.value) })
            }
            disabled={readOnly}
            className={pillInputClass}
          />
        </label>
        <label className="flex flex-col gap-2 font-sans text-xs text-text-secondary">
          Tolerance (± optional)
          <input
            type="number"
            min={0}
            value={tolerance ?? ''}
            onChange={(e) =>
              updateConfig({ tolerance: e.target.value === '' ? undefined : Number(e.target.value) })
            }
            disabled={readOnly}
            className={pillInputClass}
          />
        </label>
      </div>
    </div>
  );
}
